module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "laundry"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "md10": "",
      "pl-1": ""
    }
  }, [_c('div', {
    staticClass: "inline-filter-list"
  }, [_c('filter-list', {
    attrs: {
      "value": _vm.filterValue
    },
    on: {
      "selected-filter": _vm.selectedFilter
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "md2": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": 'Prenda',
      "href": _vm.href
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": true,
      "include-export-to-excel": true,
      "include-options": true,
      "include-switch": true,
      "include-settings": true,
      "include-delete-single": true,
      "switch-value": 'flagActive'
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn,
      "on-change-state": _vm.changeState,
      "on-delete-event": _vm.deleteRow,
      "on-delete-selected": _vm.deleteRows,
      "on-export-selected": _vm.exportToExcel,
      "go-to-edit-page": _vm.goToEdit
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', {
          staticClass: "image-column"
        }, [_c('div', {
          staticClass: "laundry-image"
        }, [_c('img', {
          attrs: {
            "src": props.row.urlImage,
            "alt": props.row.name,
            "width": "28",
            "height": "26"
          }
        })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(props.row.price)))])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPages),
      expression: "totalPages"
    }],
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e512891e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/laundry/List.vue
// module id = 1695
// module chunks = 70